import React, { useEffect, useMemo, useState } from "react";
import "./PartyMenuUI.css";
import { FaMale, FaFemale, FaCircle } from "react-icons/fa";
import { FaChevronUp, FaChevronDown } from "react-icons/fa";
import { BsThreeDots, BsCalendar2Date } from "react-icons/bs";
import { Link, useParams } from "react-router-dom";
import { CiLocationOn, CiMail } from "react-icons/ci";
import { LuPhone } from "react-icons/lu";
import axios from "axios";
import { API_BASE_URL } from "../../utils";
import { BiSliderAlt } from "react-icons/bi";

const CATEGORY_DEFS = [
    { key: "starter", label: "Veg Starters", limitKey: "starter_choice", isVeg: true },
    { key: "nonveg_starter", label: "Non-veg Starters", limitKey: "nonveg_starter_choice" },
    { key: "maincourse", label: "Veg Main Course", limitKey: "maincourse_choice", isVeg: true },
    { key: "nonveg_maincourse", label: "Non-veg Main Course", limitKey: "nonveg_maincourse_choice" },
    { key: "rice", label: "Rice & Noodles", limitKey: "rice_choice", isVeg: true },
    { key: "nonveg_rice", label: "Non-veg Rice & Noodles", limitKey: "nonveg_rice_choice" },
    { key: "breads", label: "Breads", limitKey: "breads_choice", isVeg: true },
    { key: "desserts", label: "Desserts", limitKey: "desserts_choice", isVeg: true },
    { key: "nonveg_desserts", label: "Non-veg Desserts", limitKey: "nonveg_desserts_choice" },

    // Beverages
    { key: "whiskey", label: "Whiskey", limitKey: "whiskey_choice" },
    { key: "vodka", label: "Vodka", limitKey: "vodka_choice" },
    { key: "gin", label: "Gin", limitKey: "gin_choice" },
    { key: "rum", label: "Rum", limitKey: "rum_choice" },
    { key: "tequila", label: "Tequila", limitKey: "tequila_choice" },
    { key: "beer", label: "Beer", limitKey: "beer_choice" },
    { key: "red_wine", label: "Red Wine", limitKey: "red_wine_choice" },
    { key: "white_wine", label: "White Wine", limitKey: "white_wine_choice" },
    { key: "rose_wine", label: "Rosé Wine", limitKey: "rose_wine_choice" },
    { key: "sparkling_wine", label: "Sparkling Wine", limitKey: "sparkling_wine_choice" },
    { key: "mocktails", label: "Mocktails", limitKey: "mocktails_choice" },
    { key: "cocktails", label: "Cocktails", limitKey: "cocktails_choice" },
    { key: "juice", label: "Juice", limitKey: "juice_choice" },
    { key: "soft_drinks", label: "Soft Drinks", limitKey: "soft_drinks_choice" },
];

// Map CI keys to your payload keys (e.g., maincourse -> main_course)
const CAT_KEY_TO_PAYLOAD = {
    starter: "starter",
    nonveg_starter: "nonveg_starter",
    maincourse: "main_course",
    nonveg_maincourse: "nonveg_main_course",
    rice: "rice",
    nonveg_rice: "nonveg_rice",
    breads: "breads",
    desserts: "desserts",
    nonveg_desserts: "nonveg_desserts",
    whiskey: "whiskey",
    vodka: "vodka",
    gin: "gin",
    rum: "rum",
    tequila: "tequila",
    beer: "beer",
    red_wine: "red_wine",
    white_wine: "white_wine",
    rose_wine: "rose_wine",
    sparkling_wine: "sparkling_wine",
    mocktails: "mocktails",
    cocktails: "cocktails",
    juice: "juice",
    soft_drinks: "soft_drinks",
};


const TAB_GROUPS = {
    food: [
        "soups",
        "nonveg_soups",
        "starter",
        "nonveg_starter",
        "maincourse",
        "nonveg_maincourse",
        "rice",
        "nonveg_rice",
        "breads",
        "desserts",
        "nonveg_desserts"
    ],
    nonalc: [
        "juice",
        "soft_drinks",
        "mocktails"
    ],
    alc: [
        "whiskey",
        "vodka",
        "gin",
        "rum",
        "tequila",
        "beer",
        "red_wine",
        "white_wine",
        "rose_wine",
        "sparkling_wine",
        "champagne",
        "cocktails"
    ]
};



const parseLimit = (v) => {
    if (v === undefined || v === null) return 0;
    const s = String(v).trim();
    if (s.toLowerCase() === "all") return Infinity;
    const n = parseInt(s, 10);
    return Number.isNaN(n) ? 0 : n;
};

export default function PartyMenuUI() {
    const { id } = useParams(); // order_id from route
    const [data, setData] = useState(null);
    const [activeTab, setActiveTab] = useState("food");
    const [selected, setSelected] = useState({});
    const [loading, setLoading] = useState(false);
    const [saving, setSaving] = useState(false);
    const [error, setError] = useState("");
    const [openCats, setOpenCats] = useState({ starter: true });

    const [isFinalized, setIsFinalized] = useState(false);


    const userData = localStorage.getItem("userData")
        ? JSON.parse(localStorage.getItem("userData"))
        : {};

    // add this state at top-level

    const handleFetchMenu = async () => {
        if (!id) return;
        setLoading(true);
        setError("");
        try {
            const formData = new FormData();
            formData.append("order_id", id);
            formData.append("user_id", userData.id);

            const response = await axios.post(
                `${API_BASE_URL}/master/APIs/ClubPackage/getMenuSelectionDetails`,
                formData
            );

            if (response?.data?.status) {
                const d = response.data.data || {};

                const hasFinal =
                    d.finalized_menu && typeof d.finalized_menu === "object" &&
                    Object.keys(d.finalized_menu).length > 0;

                // normalize so the rest of your code can always read from data.menu
                const normalizedMenu = hasFinal ? (d.finalized_menu || {}) : (d.menu || {});

                setIsFinalized(hasFinal);
                setData({ ...d, menu: normalizedMenu }); // overwrite .menu with whichever source we use
            } else {
                setError(response?.data?.msg || "Failed to load menu.");
            }
        } catch (err) {
            console.error(err);
            setError("Something went wrong while fetching the menu.");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        handleFetchMenu();
    }, []);



    // Build only categories present in API and with non-empty arrays
    const categories = useMemo(() => {
        if (!data?.menu) return [];
        return CATEGORY_DEFS.map((def) => {
            const arr = Array.isArray(data.menu[def.key]) ? data.menu[def.key] : [];
            if (!arr.length) return null;
            const limit = parseLimit(data[def.limitKey]);
            return {
                ...def,
                items: arr,
                limit,
                rawLimit: data[def.limitKey],
            };
        }).filter(Boolean);
    }, [data]);

    const tabs = useMemo(() => {
        return categories.map((c) => {
            let suffix = "";
            if (c.limit === Infinity) suffix = " (All)";
            else if (c.limit > 0) suffix = ` (${c.limit})`;
            return { key: c.key, label: `${c.label}${suffix}` };
        });
    }, [categories]);


    useEffect(() => {
        if (categories.length && !activeTab) {
            setActiveTab(categories[0].key);
        }
    }, [categories, activeTab]);

    const flatItems = useMemo(() => {
        return categories.flatMap((c) =>
            c.items.map((raw, idx) => {
                // raw might be either a string or an object
                const name = typeof raw === "string" ? raw : raw.item;

                return {
                    id: `${c.key}_${idx}`,
                    name,
                    catKey: c.key,
                    catLabel: c.label,
                    isVeg: !!c.isVeg,
                    // preserve backend fields
                    count: raw.count || 0,
                    users: raw.users || [],
                    selected: raw.selected || false,
                };
            })
        );
    }, [categories]);

    const itemsForTab = useMemo(() => {
        if (activeTab === "ALL") return flatItems;
        const cat = categories.find((c) => c.key === activeTab);
        if (!cat) return [];
        return cat.items.map((raw, idx) => {
            const name = typeof raw === "string" ? raw : raw.item;
            return {
                id: `${cat.key}_${idx}`,
                name,
                catKey: cat.key,
                catLabel: cat.label,
                isVeg: !!cat.isVeg,
                count: raw.count || 0,
                users: raw.users || [],
                selected: raw.selected || false,
            };
        });
    }, [activeTab, categories, flatItems]);



    const selectedCount = (catKey) => (selected[catKey]?.length || 0);
    const getLimit = (catKey) => {
        const c = categories.find((x) => x.key === catKey);
        return c ? c.limit : 0;
    };
    const isAllIncluded = (catKey) => {
        const c = categories.find((x) => x.key === catKey);
        return c?.limit === Infinity;
    };

    const toggleItem = (catKey, itemName) => {
        setSelected((prev) => {
            const current = prev[catKey] || [];
            const exists = current.includes(itemName);

            if (exists) {
                const nextCat = current.filter((n) => n !== itemName);
                return { ...prev, [catKey]: nextCat };
            }

            const limit = getLimit(catKey);
            if (limit !== Infinity && limit > 0 && current.length >= limit) {
                alert(
                    `Max ${limit} allowed in ${categories.find((c) => c.key === catKey)?.label || catKey
                    }`
                );
                return prev;
            }

            const nextCat = [...current, itemName];
            return { ...prev, [catKey]: nextCat };
        });
    };

    /** Build payload exactly as backend expects */
    const buildPayload = () => {

        const menuArray = [];

        categories.forEach((c) => {
            const itemsToSend =
                c.limit === Infinity ? c.items : (selected[c.key] || []);

            if (itemsToSend.length) {
                const rows = itemsToSend.map((itemObj) => ({
                    user_id: userData?.id,
                    item:
                        typeof itemObj === "string"
                            ? itemObj
                            : itemObj.item || itemObj?.item?.item, // ✅ flatten nested object
                }));

                const payloadKey = CAT_KEY_TO_PAYLOAD[c.key] || c.key;
                menuArray.push({ [payloadKey]: rows });
            }
        });

        return {
            order_id: id,
            user_id: userData?.id,
            menu: menuArray,
        };
    };

    const isMenuComplete = useMemo(() => {
        return categories.every((cat) => {
            const chosen = selected[cat.key] || [];

            if (cat.limit === Infinity) return true;

            return chosen.length === cat.limit;
        });
    }, [categories, selected]);

    useEffect(() => {
        if (!categories.length) return;
        setSelected((prev) => {
            const next = { ...prev };
            categories.forEach((c) => {
                if (c.limit === Infinity) {
                    // Preselect everything automatically
                    const names = c.items.map((raw) =>
                        typeof raw === "string" ? raw : raw.item
                    );
                    next[c.key] = names;
                }
            });
            return next;
        });
    }, [categories]);



    const handleSubmit = async () => {


        if (!id || !categories.length) return;

        if (!isMenuComplete) {
            alert("Please select all items.");
            return;
        }

        let payload;
        try {
            payload = buildPayload();
        } catch (e) {
            alert(e.message || "Cannot build payload.");
            return;
        }


        setSaving(true);
        try {
            const res = await axios.post(
                `${API_BASE_URL}/master/APIs/ClubPackage/saveGroupBookingItems`,
                payload,
                {
                    headers: { "Content-Type": "application/json" }
                }
            );

            if (res?.data?.status) {
                alert("Menu saved successfully!");
                handleFetchMenu();
            } else {
                alert(res?.data?.msg || "Failed to save menu.");
            }
        } catch (e) {
            console.error(e);
            alert("Something went wrong while saving.");
        } finally {
            setSaving(false);
        }
    };



    const venueImages = [
        "https://images.unsplash.com/photo-1528605105345-5344ea20e269?q=80&w=800&auto=format&fit=crop",
        "https://images.unsplash.com/photo-1528605248644-14dd04022da1?q=80&w=800&auto=format&fit=crop",
        "https://images.unsplash.com/photo-1544025162-d76694265947?q=80&w=800&auto=format&fit=crop",
    ];

    const formatDate = (iso) => {
        if (!iso) return "";
        try {
            return new Date(iso).toLocaleDateString(undefined, {
                day: "2-digit",
                month: "long",
                year: "numeric",
            });
        } catch {
            return iso;
        }
    };

    return (
        <div className="pmu-app">
            <div className="pmu-grid">
                {/* Left column */}
                <div className="pmu-left">
                    {/* Header */}
                    <header className="pmu-header">
                        <h1 className="pmu-title">{data?.package_title_name || "Customize Your Package"}</h1>
                    </header>

                    {/* Venue Card */}
                    <section className="pmu-card pmu-venue">
                        <div className="pmu-photos">
                            {venueImages.map((src, i) => (
                                <img key={i} src={src} alt={`venue ${i + 1}`} />
                            ))}
                        </div>

                        <div className="pmu-venue-info">
                            <h3 className="pmu-venue-name">{data?.club_name || "--"}</h3>

                            <div className="pmu-venue-meta">
                                <span className="pmu-meta-chip">
                                    <CiLocationOn /> {data?.club_address || "--"}
                                </span>
                                <span className="pmu-meta-chip">
                                    <BsCalendar2Date /> {formatDate(data?.party_date)}, {data?.party_time}
                                </span>
                            </div>

                            <div className="pmu-rating">
                                <span className="pmu-ico pmu-ico-star" />
                                <strong>4.8</strong> (128 reviews)
                            </div>
                        </div>
                    </section>

                    {/* Party Details */}
                    <section className="pmu-card pmu-party">
                        <h4 className="pmu-sec-title">Party Details</h4>

                        <div className="pmu-stats">
                            <div className="pmu-stat">
                                <span className="pmu-stat-ico ">
                                    <FaMale />
                                </span>
                                <div>
                                    <div className="pmu-stat-label">Male Guests</div>
                                    <div className="pmu-stat-value">{data?.male || data?.male_qty || 0}</div>
                                </div>
                            </div>
                            <div className="pmu-stat">
                                <span className="pmu-stat-ico ">
                                    <FaFemale />
                                </span>
                                <div>
                                    <div className="pmu-stat-label">Female Guests</div>
                                    <div className="pmu-stat-value">{data?.female || data?.female_qty || 0}</div>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>

                {/* Right column */}
                <aside className="pmu-right">
                    <div className="pmu-menu surface">
                        <div className="pmu-menu-head">
                            <h2>Customize Your Menu</h2>
                            <div className="pmu-head-actions">
                                <button className="pmu-icon-btn">
                                    <BiSliderAlt />
                                </button>
                                <button className="pmu-icon-btn">
                                    <BsThreeDots />
                                </button>
                            </div>
                        </div>

                        {/* Tabs */}
                        <div className="pmu-tabs">
                            <button
                                className={`pmu-tab ${activeTab === "food" ? "is-active" : ""}`}
                                onClick={() => setActiveTab("food")}
                            >
                                Food Menu
                            </button>
                            <button
                                className={`pmu-tab ${activeTab === "nonalc" ? "is-active" : ""}`}
                                onClick={() => setActiveTab("nonalc")}
                            >
                                Non-Alcoholic
                            </button>
                            <button
                                className={`pmu-tab ${activeTab === "alc" ? "is-active" : ""}`}
                                onClick={() => setActiveTab("alc")}
                            >
                                Alcoholic
                            </button>
                        </div>

                        {/* Accordions (filtered by tab) */}
                        <div className="pmu-accordions">
                            {categories
                                .filter((cat) => TAB_GROUPS[activeTab]?.includes(cat.key))
                                .map((cat) => {
                                    const chosen = selected[cat.key] || [];
                                    const limitHit =
                                        chosen.length >= cat.limit && cat.limit !== Infinity;
                                    const isOpen = openCats[cat.key];
                                    const pad2 = (n) => String(n).padStart(2, "0");

                                    return (
                                        <div className="pmu-acc" key={cat.key}>
                                            <button
                                                className="pmu-acc-head"
                                                onClick={() =>
                                                    setOpenCats((s) => ({ ...s, [cat.key]: !s[cat.key] }))
                                                }
                                            >
                                                <div className="pmu-acc-title">{cat.label}</div>
                                                <div>
                                                    {!isFinalized && (<>
                                                        <span className="pmu-acc-count">
                                                            {cat.limit === Infinity
                                                                ? "(All)"
                                                                : `(${pad2(chosen.length)}/${pad2(cat.limit)})`}
                                                        </span>
                                                    </>)}
                                                    {isOpen ? (
                                                        <FaChevronUp color="#6b7280" />
                                                    ) : (
                                                        <FaChevronDown color="#6b7280" />
                                                    )}
                                                </div>
                                            </button>

                                            {isOpen && (
                                                <div className="pmu-acc-body">
                                                    {cat.items.map((raw, idx) => {
                                                        const name =
                                                            typeof raw === "string" ? raw : raw.item;
                                                        const checked = chosen.includes(name);
                                                        return (
                                                            <div className="pmu-row" key={idx}>
                                                                {raw.users.length > 0 && (
                                                                    <div className="pmu-item-users-count-wrap">
                                                                        <div className="pmu-item-users-profile">
                                                                            {(
                                                                                raw.users[0]?.name?.split(" ")[0]?.[0] ||
                                                                                "U"
                                                                            ).toUpperCase()}
                                                                        </div>
                                                                        <p>
                                                                            {raw.users?.length > 0
                                                                                ? raw.users[0]?.name?.split(" ")[0] ||
                                                                                "User"
                                                                                : "User"}
                                                                        </p>
                                                                        {raw.users.length > 1 && (
                                                                            <span>& {raw.users.length - 1}+</span>
                                                                        )}
                                                                    </div>
                                                                )}
                                                                <div className="pmu-item-wrap">
                                                                    <img
                                                                        className="pmu-thumb"
                                                                        src="https://images.unsplash.com/photo-1504674900247-0877df9cc836?w=600"
                                                                        alt={name}
                                                                    />
                                                                    <div className="pmu-col">
                                                                        <h5 className="pmu-item-title">
                                                                            {cat.isVeg && (
                                                                                <span className="pmu-badge-veg">
                                                                                    <FaCircle />
                                                                                </span>
                                                                            )}
                                                                            {name}
                                                                        </h5>
                                                                        <p className="pmu-sub">Enjoy a refresh…</p>
                                                                        <button className="pmu-link">View More</button>
                                                                    </div>
                                                                    <label className="pmu-check">
                                                                        {!isFinalized && (

                                                                            <input
                                                                                type="checkbox"
                                                                                checked={checked}
                                                                                onChange={() => toggleItem(cat.key, name)}
                                                                            />
                                                                        )}
                                                                        <span className="pmu-checkmark" />
                                                                    </label>
                                                                </div>
                                                            </div>
                                                        );
                                                    })}

                                                    {limitHit && (
                                                        <div className="pmu-limit">
                                                            Maximum limit reached – only {cat.limit} selections
                                                            allowed.
                                                        </div>
                                                    )}
                                                </div>
                                            )}
                                        </div>
                                    );
                                })}
                        </div>

                        {/* Footer actions */}
                        <div className="pmu-footer">
                            {!isFinalized && (

                                <button
                                    className={`pmu-btn pmu-btn-primary ${!isMenuComplete ? "pmu-is-disabled" : ""
                                        }`}
                                    style={{ width: "100%" }}
                                    onClick={handleSubmit}
                                    disabled={saving || !isMenuComplete}
                                >
                                    {saving ? "Saving…" : "Submit Menu"}
                                </button>
                            )}
                            {id && (
                                <Link to={`/add-guest/${id}`} style={{ width: "100%" }}>
                                    <button className="pmu-btn pmu-btn-link">
                                        Next: Add Guests
                                    </button>
                                </Link>
                            )}
                            {/* <Link to={`/add-guest/${id}`} style={{ width: "100%" }}>
                                <button className="pmu-btn pmu-btn-link">
                                    Next: Add Guests
                                </button>
                            </Link> */}
                        </div>
                    </div>
                </aside>

            </div>
        </div>
    );
}
